// Shift+right-click bypasses the custom context menu so users
// can access the browser's native menu (copy, inspect, etc.).
// Shift+click normally extends the text selection in browsers,
// so we clear it to avoid leftover highlighted text.
// https://developer.mozilla.org/en-US/docs/Web/API/Selection/removeAllRanges
export function shouldBypassContextMenu(e) {
  if (e.shiftKey) {
    var _window$getSelection;
    (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 || _window$getSelection.removeAllRanges();
    return true;
  }
  return false;
}